"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LarixUserInfo = void 0;
const models_1 = require("../models");
const spl_token_1 = require("@solana/spl-token");
const config_1 = require("../config");
const buffer_layout_1 = __importDefault(require("buffer-layout"));
const models_2 = require("../models");
const models_3 = require("../models");
const models_4 = require("../models");
const utils_1 = require("../utils");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
class LarixUserInfo {
    constructor(publicKey, connection, markets) {
        this.tokenAccounts = new Map();
        this.publicKey = publicKey;
        this.connection = connection;
        this.markets = markets;
        this.marketDetails = [];
    }
    loadTokenAccounts() {
        return __awaiter(this, void 0, void 0, function* () {
            this.tokenAccounts = yield this.getTokenAccounts();
        });
    }
    setTokenAccounts(tokenAccounts) {
        this.tokenAccounts = tokenAccounts;
    }
    loadUserInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            this.marketDetails = [];
            const promiseArray = [];
            this.markets.forEach(market => {
                const programId = market.config.programId;
                const marketId = market.config.marketId;
                promiseArray.push(this.getMining(programId, [marketId]));
                promiseArray.push(this.getObligation(programId, [marketId]));
            });
            const response = yield Promise.all(promiseArray);
            let index = 0;
            for (const market of this.markets) {
                const userDetail = {
                    market,
                    mining: undefined,
                    obligations: []
                };
                // @ts-ignore
                const minings = response[index++].get(market.config.marketId.toString());
                if (minings && minings.length > 0) {
                    const mining = minings[0]; // always only one now
                    userDetail.mining = this.getLarixMining(market, mining);
                    // @ts-ignore
                    const obligations = response[index++].get(market.config.marketId.toString());
                    if (obligations && obligations.length > 0) {
                        for (const obligationState of obligations) {
                            const obligation = this.getLarixObligation(market, obligationState);
                            userDetail.obligations.push(obligation);
                        }
                    }
                }
                else {
                    index++;
                }
                this.marketDetails.push(userDetail);
            }
        });
    }
    bindTokenAccountToReserve() {
        this.markets.forEach(market => {
            market.reserves.forEach(reserve => {
                let tokenAccounts = this.tokenAccounts.get(reserve.state.info.collateral.mintPubkey.toString());
                if (tokenAccounts && tokenAccounts.length > 0) {
                    reserve.userCollateralTokenAccount = tokenAccounts[0];
                }
                tokenAccounts = this.tokenAccounts.get(reserve.state.info.liquidity.mintPubkey.toString());
                if (tokenAccounts && tokenAccounts.length > 0) {
                    reserve.userLiquidityTokenAccount = tokenAccounts[0];
                    reserve.userLiquidityAmount = (0, utils_1.eX)(reserve.userLiquidityTokenAccount.info.amount.toString(), -reserve.state.info.liquidity.mintDecimals);
                }
                else {
                    reserve.userLiquidityAmount = new bignumber_js_1.default(0);
                }
            });
        });
    }
    getLiquidityTokenAccount(reserve) {
        if (reserve.userLiquidityTokenAccount) {
            return reserve.userLiquidityTokenAccount;
        }
        const tokenAccounts = this.tokenAccounts.get(reserve.state.info.liquidity.mintPubkey.toString());
        return tokenAccounts && tokenAccounts.length > 0 ? tokenAccounts[0] : undefined;
    }
    getCollateralTokenAccount(reserve) {
        if (reserve.userCollateralTokenAccount) {
            return reserve.userCollateralTokenAccount;
        }
        const tokenAccounts = this.tokenAccounts.get(reserve.state.info.collateral.mintPubkey.toString());
        return tokenAccounts && tokenAccounts.length > 0 ? tokenAccounts[0] : undefined;
    }
    getLarixObligation(market, obligationSate) {
        const obligation = {
            state: obligationSate,
            market,
            totalDeposit: new bignumber_js_1.default(0),
            borrowLimit: new bignumber_js_1.default(0),
            liquidateLimit: new bignumber_js_1.default(0),
            totalBorrow: new bignumber_js_1.default(0),
            rewardAmount: new bignumber_js_1.default(0),
            deposits: [],
            borrows: []
        };
        obligationSate.info.deposits.forEach(deposit => {
            const reserve = market.reservesMap.get(deposit.depositReserve.toString());
            if (reserve === undefined) {
                return;
            }
            const amount = (0, utils_1.eX)(deposit.depositedAmount.toString(), -reserve.state.info.liquidity.mintDecimals);
            const value = amount.times(reserve.liquidityPrice);
            const collateral = {
                reserve,
                amount,
                value,
                rewardAmount: new bignumber_js_1.default(0)
            };
            obligation.deposits.push(collateral);
            obligation.totalDeposit = obligation.totalDeposit.plus(value);
            obligation.borrowLimit = obligation.borrowLimit.plus(value.times(reserve.collateralFactor));
            obligation.liquidateLimit = obligation.liquidateLimit.plus(value.times(reserve.liquidationThreshold));
        });
        obligationSate.info.borrows.forEach(borrow => {
            const reserve = market.reservesMap.get(borrow.borrowReserve.toString());
            if (reserve === undefined) {
                return;
            }
            const userCumulativeBorrowRate = (0, utils_1.eX)(borrow.cumulativeBorrowRateWads.toString(), -18);
            const compoundedInterestRate = reserve.cumulativeBorrowRate.div(userCumulativeBorrowRate);
            const amount = (0, utils_1.eX)(borrow.cumulativeBorrowRateWads.toString(), -18 - reserve.state.info.liquidity.mintDecimals).times(compoundedInterestRate);
            const liquidity = {
                reserve,
                amount,
                value: amount.times(reserve.liquidityPrice),
                rewardAmount: new bignumber_js_1.default(0),
            };
            obligation.borrows.push(liquidity);
            obligation.totalBorrow = obligation.totalBorrow.plus(liquidity.value);
        });
        return obligation;
    }
    getLarixMining(market, miningState) {
        const mining = {
            state: miningState,
            market: market,
            totalValue: new bignumber_js_1.default(0),
            rewardAmount: new bignumber_js_1.default(0),
            detail: []
        };
        miningState.info.miningIndices.forEach(miningIndex => {
            const reserve = market.reservesMap.get(miningIndex.reserve.toString());
            if (reserve === undefined) {
                return;
            }
            const amount = (0, utils_1.eX)(miningIndex.unCollLTokenAmount.toString(), -reserve.state.info.liquidity.mintDecimals);
            const value = amount.times(reserve.liquidityPrice);
            const miningDetail = {
                reserve: reserve,
                amount,
                value
            };
            mining.totalValue = mining.totalValue.plus(value);
            mining.detail.push(miningDetail);
        });
        return mining;
    }
    getTokenAccounts() {
        return __awaiter(this, void 0, void 0, function* () {
            const tokenAccountsMap = new Map();
            yield Promise.all([
                LarixUserInfo.getSolToken(this.connection, tokenAccountsMap, this.publicKey),
                this.getOtherToken(this.connection, tokenAccountsMap, this.publicKey),
            ]);
            return tokenAccountsMap;
        });
    }
    getObligation(programID, marketIDs) {
        return __awaiter(this, void 0, void 0, function* () {
            const accountInfos = yield this.connection.getProgramAccounts(programID, {
                filters: [
                    {
                        dataSize: models_2.ObligationLayout.span
                    },
                    {
                        memcmp: {
                            offset: buffer_layout_1.default.u8('version').span + models_3.LastUpdateLayout.span + 32,
                            /** data to match, as base-58 encoded string and limited to less than 129 bytes */
                            bytes: this.publicKey.toBase58()
                        }
                    }
                ]
            });
            const result = new Map();
            marketIDs.forEach(marketID => {
                let obligations = new Array();
                accountInfos.map(function (item) {
                    const obligation = (0, models_2.ObligationParser)(item.pubkey, item.account);
                    if (obligation.info.lendingMarket.equals(marketID)) {
                        obligations.push(obligation);
                    }
                });
                obligations =
                    obligations.sort((a, b) => {
                        return b.pubkey.toString().localeCompare(a.pubkey.toString());
                    });
                result.set(marketID.toString(), obligations);
            });
            return result;
        });
    }
    getMining(lendingProgramID, lendingMarketIDs) {
        return __awaiter(this, void 0, void 0, function* () {
            const accountInfos = yield this.connection.getProgramAccounts(lendingProgramID, {
                filters: [
                    {
                        dataSize: models_4.MiningLayout.span
                    },
                    {
                        memcmp: {
                            offset: buffer_layout_1.default.u8('version').span,
                            /** data to match, as base-58 encoded string and limited to less than 129 bytes */
                            bytes: this.publicKey.toBase58()
                        }
                    }
                ]
            });
            // console.log("accountInfos",accountInfos)
            const result = new Map();
            lendingMarketIDs.forEach(lendingMarketID => {
                const minings = new Array();
                accountInfos.map(function (item) {
                    const mining = (0, models_4.MiningParser)(item.pubkey, item.account);
                    if (mining.info.lendingMarket.equals(lendingMarketID)) {
                        minings.push(mining);
                    }
                });
                result.set(lendingMarketID.toString(), minings);
            });
            return result;
        });
    }
    getObligationOfMarket(programID, marketID) {
        return __awaiter(this, void 0, void 0, function* () {
            const accountInfos = yield this.connection.getProgramAccounts(programID, {
                filters: [
                    {
                        dataSize: models_2.ObligationLayout.span
                    },
                    {
                        memcmp: {
                            offset: buffer_layout_1.default.u8('version').span + models_3.LastUpdateLayout.span + 32,
                            /** data to match, as base-58 encoded string and limited to less than 129 bytes */
                            bytes: this.publicKey.toBase58()
                        }
                    }
                ]
            });
            let obligations = new Array();
            accountInfos.map(function (item) {
                const obligation = (0, models_2.ObligationParser)(item.pubkey, item.account);
                if (obligation.info.lendingMarket.equals(marketID)) {
                    obligations.push(obligation);
                }
            });
            obligations =
                obligations.sort((a, b) => {
                    return b.pubkey.toString().localeCompare(a.pubkey.toString());
                });
            return obligations;
        });
    }
    getMiningOfMarket(lendingProgramID, lendingMarketID) {
        return __awaiter(this, void 0, void 0, function* () {
            const accountInfos = yield this.connection.getProgramAccounts(lendingProgramID, {
                filters: [
                    {
                        dataSize: models_4.MiningLayout.span
                    },
                    {
                        memcmp: {
                            offset: buffer_layout_1.default.u8('version').span,
                            /** data to match, as base-58 encoded string and limited to less than 129 bytes */
                            bytes: this.publicKey.toBase58()
                        }
                    }
                ]
            });
            const minings = new Array();
            accountInfos.map(function (item) {
                const mining = (0, models_4.MiningParser)(item.pubkey, item.account);
                if (mining.info.lendingMarket.equals(lendingMarketID)) {
                    minings.push(mining);
                }
            });
            return minings;
        });
    }
    static getSolToken(connection, tokenAccountsMap, userAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const userAccount = yield connection.getAccountInfo(userAddress);
            if (userAccount !== null) {
                tokenAccountsMap.set(config_1.WRAPPED_SOL_MINT.toString(), [{
                        pubkey: userAddress,
                        account: userAccount,
                        info: {
                            address: userAddress,
                            mint: config_1.WRAPPED_SOL_MINT,
                            owner: userAddress,
                            amount: new spl_token_1.u64(userAccount.lamports),
                            delegate: null,
                            delegatedAmount: new spl_token_1.u64(0),
                            isInitialized: true,
                            isFrozen: false,
                            isNative: true,
                            rentExemptReserve: null,
                            closeAuthority: null,
                        }
                    }]);
            }
        });
    }
    getOtherToken(connection, tokenAccountsMap, userAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const accountsInfo = yield connection.getTokenAccountsByOwner(userAddress, {
                programId: spl_token_1.TOKEN_PROGRAM_ID
            });
            accountsInfo.value
                .map(function (item) {
                const tokenAccount = (0, models_1.TokenAccountParser)(item.pubkey, item.account);
                if (tokenAccountsMap.has(tokenAccount.info.mint.toString())) {
                    const tokenAccounts = tokenAccountsMap.get(tokenAccount.info.mint.toString());
                    if (tokenAccounts != undefined) {
                        tokenAccounts.push(tokenAccount);
                    }
                }
                else {
                    const tokenAccounts = new Array();
                    tokenAccounts.push(tokenAccount);
                    tokenAccountsMap.set(tokenAccount.info.mint.toString(), tokenAccounts);
                }
            });
            for (const tokenAccounts of tokenAccountsMap.values()) {
                if (tokenAccounts.length > 1) {
                    const associatedAccount = yield spl_token_1.Token.getAssociatedTokenAddress(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, tokenAccounts[0].info.mint, userAddress);
                    tokenAccounts.sort((a, b) => {
                        if (b.info.isNative || b.pubkey.equals(associatedAccount)) {
                            return 1;
                        }
                        else if (a.info.isNative || a.pubkey.equals(associatedAccount)) {
                            return -1;
                        }
                        else {
                            return b.info.amount.toNumber() - a.info.amount.toNumber();
                        }
                    });
                }
            }
        });
    }
}
exports.LarixUserInfo = LarixUserInfo;
